import { useMemo } from "react";

/**
 * Trie une liste de projets.
 *  - order = null        → ordre d'origine (aucun changement)
 *  - order = "recent"    → du plus récent au plus ancien
 *  - order = "oldest"    → du plus ancien au plus récent
 *
 * La date est lue dans `item.date` si elle existe (ex: "2024-05-12"),
 * sinon on utilise `item.id` (plus l'id est grand, plus le projet est récent).
 */
export function useSortedItems(items, order) {
  return useMemo(() => {
    if (!order) return items;

    const weight = (item) =>
      item.date ? new Date(item.date).getTime() : item.id;

    return [...items].sort((a, b) =>
      order === "recent" ? weight(b) - weight(a) : weight(a) - weight(b)
    );
  }, [items, order]);
}
